import config from '@/config/index'

import { ResourceLinkType } from 'types/api.graphql'

export const encodeResourceLink = (
  resource: ResourceLinkType,
  slug: string
): string => {
  const string = `${resource}:${slug}`

  // encode the string
  // Ensure URI safe characters are used
  return Buffer.from(string, 'ascii')
    .toString('base64')
    .replace(/\+/g, '-') // Convert '+' to '-'
    .replace(/\//g, '_') // Convert '/' to '_'
    .replace(/=+$/, '') // Remove ending '='
}

export const decodeResourceLink = (
  encodedSlug: string
): { resource: string; slug: string } => {
  const decodedLink = Buffer.from(encodedSlug, 'base64').toString('ascii')
  const [resource, slug] = decodedLink.split(':')

  return { resource, slug }
}

export const constructResourceLink = (
  resource: ResourceLinkType,
  slug: string
) => {
  const encodedSlug = encodeResourceLink(resource, slug)

  return `${config.appHost}/public/resource/${encodedSlug}`
}
